import { z } from "zod";

export function normalizeHashtag(value: string): string | null {
  const body = value
    .trim()
    .replace(/ي/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/^_+|_+$/g, "");

  if (!body) return null;
  return body;
}

export function parseTagQuery(
  values?: Array<string | null | undefined> | string | null,
): string[] | undefined {
  if (values == null || values === "") return undefined;

  const list = (Array.isArray(values) ? values : [values])
    .flatMap((value) => String(value).split(/[,،]/))
    .map((value) => normalizeHashtag(value))
    .filter((value): value is string => Boolean(value));
  const unique = [...new Set(list)];

  return unique.length ? unique : undefined;
}

export const tagQuerySchema = z
  .union([z.string(), z.array(z.string())])
  .optional()
  .nullable()
  .transform((value) => parseTagQuery(value)?.join(","));
